import { Info } from 'lucide-react';
import { useRecoveryCodes } from '../../hooks/useRecoveryCodes';

const RecoveryCodes = () => {
  const { codes, showCodes, loading, error } = useRecoveryCodes();

  const downloadRecoveryCodes = () => {
    const blob = new Blob([codes.join('\n')], { type: 'text/plain' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'recovery_codes.txt';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      {/* 🔹 Mostrar solo si `showCodes` es true o si está cargando */}
      {(showCodes || loading) && (
        <div className="mt-4">
          <h2 className="text-xl font-semibold text-black dark:text-white">
            Descargue sus códigos de recuperación
          </h2>

          <div className="mt-4 flex items-start rounded-lg border border-blue-500 bg-blue-50 p-4">
            <Info className="mr-3 h-6 w-6 text-blue-500" />{' '}
            {/* Icono de información */}
            <div>
              <p className="font-semibold text-blue-700">
                Guarde sus códigos de recuperación en un lugar seguro
              </p>
              <p className="text-blue-700">
                Puede utilizar códigos de recuperación como segundo factor de
                autenticación en caso de que pierda acceso a su dispositivo.
              </p>
            </div>
          </div>

          {/* 🔹 Mostrar mensaje mientras se generan los códigos */}
          {loading ? (
            <p className="text-gray-600 mt-4">
              Generando códigos de recuperación...
            </p>
          ) : (
            <>
              {/* 🔹 Mostrar lista de códigos cuando se generen */}
              {showCodes && (
                <div className="bg-gray-100 mt-2 flex justify-center rounded p-6">
                  <div className="grid grid-cols-2 gap-2 text-center">
                    {codes.map((code, index) => (
                      <div
                        key={index}
                        className="flex items-center justify-center space-x-2 px-4 py-1 font-bold text-black dark:text-white"
                      >
                        <span className="text-xl">•</span>
                        <span>{code}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* 🔹 Botón para descargar los códigos solo si ya fueron generados */}
              {showCodes && (
                <button
                  className="mt-4 rounded bg-primary px-4 py-2 text-white hover:bg-opacity-90"
                  onClick={downloadRecoveryCodes}
                >
                  Descargar Códigos
                </button>
              )}
            </>
          )}

          {/* 🔹 Mensaje de error si ocurre un problema */}
          {error && <p className="mt-2 text-red">{error}</p>}
        </div>
      )}
    </>
  );
};

export default RecoveryCodes;
